import { Tier, CareerCategory } from '@backrs_ui/common-ui';

import {
  CareerUserResponseSet,
  CareerPathWithScore,
  CareerQuestion,
} from '@backrs_ui/grow-ui/src/models/models';

import { Document } from '@react-pdf/renderer';

import { ResultPageFour } from './ResultPageFour';
import { ResultPageOne } from './ResultPageOne';
import { ResultPageThree } from './ResultPageThree';
import { ResultPageTwo } from './ResultPageTwo';

export type ResultDocumentPDFProps = Readonly<{
  tier: Tier;
  entrepreneurshipRecommended: boolean;
  userResponseSet: CareerUserResponseSet;
  careerPathSuggestions: CareerPathWithScore[];
  careerQuestions: CareerQuestion[];
  careerPathCategories: CareerCategory[];
  firstName?: string;
  lastName?: string;
  createdAt: string;
}>;

export async function ResultDocumentPDF({
  tier,
  entrepreneurshipRecommended,
  userResponseSet,
  careerPathSuggestions,
  careerQuestions,
  careerPathCategories,
  firstName,
  lastName,
  createdAt,
}: ResultDocumentPDFProps) {
  return (
    <Document>
      {/* MINIMUM TRACK, EXPLANATION, AND ASPIRATIONS */}
      <ResultPageOne
        tier={tier}
        entrepreneurshipRecommended={entrepreneurshipRecommended}
        firstName={firstName}
        lastName={lastName}
        createdAt={createdAt}
        userResponseSet={userResponseSet}
        careerQuestions={careerQuestions}
      />

      {/* BEST FIT CAREER PATHS AND POTENTIAL CAREER PATHS */}
      <ResultPageTwo
        careerPathSuggestions={careerPathSuggestions}
        careerPathCategories={careerPathCategories}
      />

      {/* ALL MARKERS OF SUCCESS FOR HIGH SCHOOL LEVEL, AND COLLEGE PAGE ONE */}
      <ResultPageThree schoolLevel={userResponseSet.school_level} tier={tier} />

      {/* MARKERS OF SUCCESS SECOND PAGE FOR COLLEGE LEVEL - WE RENDER A SECOND PAGE FOR COLLEGE INTENTIONALLY SINCE REACT-PDF ISN'T SMART ENOUGH TO HANDLE PAGE BREAKS */}
      {userResponseSet.school_level !== 'high_school' && <ResultPageFour tier={tier} />}
    </Document>
  );
}
